import Vue from "vue"
import App from "./App.vue"
import "./registerServiceWorker"
import store from './store'
import router from "./router"
import Vant from "vant"
import "vant/lib/index.css"
import VueResource from "vue-resource"
import Element from "element-ui"
import i18n from './i18n/index' //国际化

Vue.use(Element)
Vue.use(Vant)
Vue.use(VueResource)
Vue.config.ignoredElements = ["wx-open-launch-weapp"]
Vue.config.productionTip = false
Vue.http.interceptors.push((request, next) => {
  let token = localStorage.getItem("token")
  request.headers.set("Authorization", token)
  next(function (response) {
    return response
  })
})

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount("#app")
